import { QuoteSetupItems } from '@/models/cart'
import { Service } from '@/models/service'
import { getBoughtServicesTotal } from './timeSchedules'

export const getGroupBoughtQuantity = ({
  groupId,
  ticketServices,
  selectedElementQuotableProducts,
}: {
  groupId: number
  ticketServices: Service[]
  selectedElementQuotableProducts: QuoteSetupItems
}) => {
  const groupedServicesIds = ticketServices
    .filter((ticket) => ticket.serviceGroupId === groupId)
    .map((ticket) => ticket.serviceId)

  const { boughtServices } = selectedElementQuotableProducts
  return Object.keys(boughtServices).reduce((carry, key) => {
    const serviceId = Number(key)
    if (groupedServicesIds.includes(serviceId)) {
      return carry + getBoughtServicesTotal(boughtServices[serviceId])
    }
    return carry
  }, 0)
}
